export enum ViewMode {
  Video = 'video',
  Chat = 'chat'
}
